import { StringUtility } from '@common/utils';
import { IModel, Model } from './Model';
import { DateTime } from 'luxon';
import { makeObservable, observable } from 'mobx';

export interface IVisitEventModel extends IModel {
  checkinTime: string | undefined;
  confirmationSMSSent: string | undefined;
  consultationStart: string | undefined;
  consultation2Start: string | undefined;
  vetServicesStart: string | undefined;
  checkoutTime: string | undefined;
  inProgressStart: string | undefined;
  admittedStart: string | undefined;
  finalizedStart: string | undefined;
  finalizedComplete: string | undefined;
  paidStart: string | undefined;
}

export class VisitEventModel
  extends Model
  implements Record<keyof IVisitEventModel, any>
{
  @observable checkinTime: DateTime | undefined;
  @observable confirmationSMSSent: DateTime | undefined;
  @observable consultationStart: DateTime | undefined;
  @observable consultation2Start: DateTime | undefined;
  @observable vetServicesStart: DateTime | undefined;
  @observable checkoutTime: DateTime | undefined;
  @observable inProgressStart: DateTime | undefined;
  @observable admittedStart: DateTime | undefined;
  @observable finalizedStart: DateTime | undefined;
  @observable finalizedComplete: DateTime | undefined;
  @observable paidStart: DateTime | undefined;

  constructor(params: IVisitEventModel) {
    super(params);
    this.checkinTime = StringUtility.SanitizeDateTimeISOAsUtc(
      params.checkinTime,
    );
    this.confirmationSMSSent = StringUtility.SanitizeDateTimeISOAsUtc(
      params.confirmationSMSSent,
    );
    this.consultationStart = StringUtility.SanitizeDateTimeISOAsUtc(
      params.consultationStart,
    );
    this.consultation2Start = StringUtility.SanitizeDateTimeISOAsUtc(
      params.consultation2Start,
    );
    this.vetServicesStart = StringUtility.SanitizeDateTimeISOAsUtc(
      params.vetServicesStart,
    );
    this.checkoutTime = StringUtility.SanitizeDateTimeISOAsUtc(
      params.checkoutTime,
    );
    this.inProgressStart = StringUtility.SanitizeDateTimeISOAsUtc(
      params.inProgressStart,
    );
    this.admittedStart = StringUtility.SanitizeDateTimeISOAsUtc(
      params.admittedStart,
    );
    this.finalizedStart = StringUtility.SanitizeDateTimeISOAsUtc(
      params.finalizedStart,
    );
    this.finalizedComplete = StringUtility.SanitizeDateTimeISOAsUtc(
      params.finalizedComplete,
    );
    this.paidStart = StringUtility.SanitizeDateTimeISOAsUtc(params.paidStart);

    makeObservable(this);
  }
}
